import $ from './jquery-shim.js';
import 'owl.carousel';
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css";
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css";

var defaultOptions = {
  selector: '.owl-carousel',
};

export default class OwlCarousel {
  /**
   * 初期化
   * @param options
   */
  constructor(options) {
    this.options = $.extend(defaultOptions, options);
    this.init();
  }

  /**
   * 初期化
   */
  init() {

    // ターゲットを取得する
    this.targetAll = $(this.options.selector);


    // ターゲットが存在しない場合は実行しない
    if (!this.targetAll.length) {
      return false;
    }

    // 実行する
    this.run();
  }

  /**
   * 実行する
   */


  run() {

    // const gsap = this.options.gsap;

    //->スライダー
    this.targetAll.imagesLoaded(function () {
      $('.c-main-visual__slider').owlCarousel({
        items: 1,
        margin: 0,
        dots: true,
        loop: true,
        nav: false,
        onInitialized: function () {
          // gsap.animate
        },
        autoplayHoverPause: true,
        autoplay: true,
        autoplaySpeed: 500,
        autoWidth: false,
        autoHeight: false,
        center: true,
        animateOut: 'fadeOut',
        navText: ['<img src="/wp-content/themes/kobesandaya-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/kobesandaya-html/dist/assets/images/icon-slider-next.svg" />'],
      });
      var dotItem = $('.owl-dots button');
      var dotNum = 0;
      var win = $(window).innerWidth();
      for (var i = 0; dotItem.length > i; i++) {
        dotNum++;
        dotItem.find('span').eq(i).text("0" + dotNum);

        if (win < 950) {
          dotItem.find('span').eq(i).text("0" + (dotNum - 3));
        }
      }
    });

    //->カード_カルーセル（トップページの店舗紹介）
    this.targetAll.imagesLoaded(function () {

      // 750以上の時かつ、3個以上の時
      if ($(window).innerWidth() > 950) {

        if ($('.js-card-slider').find('.c-card-store__block').length < 3){

          $('.js-card-slider').toggleClass('owl-carousel');
          return false;
        } else {
          $('.js-card-slider').owlCarousel({
            margin: 0,
            dots: true,
            loop: true,
            nav: false,
            autoplayHoverPause: true,
            autoplay: true,
            autoplaySpeed: 500,
            autoWidth: true,
            autoHeight: false,
            center: true,
          });
        }
      }
      // 950以下の時
      else {
        $('.js-card-slider').owlCarousel({
          margin: 0,
          dots: true,
          loop: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: true,
          autoHeight: false,
          center: true,
        });
      }
    });

    //->バナー_カルーセル（トップページのキャンペーン）
    this.targetAll.imagesLoaded(function () {

      $('.js-banner-slider').owlCarousel({
        margin: 0,
        dots: true,
        loop: true,
        nav: false,
        autoplayHoverPause: true,
        autoplay: true,
        autoplaySpeed: 500,
        autoWidth: true,
        autoHeight: false,
        center: true,
      });
    });

    //->レストランメニュー
    this.targetAll.imagesLoaded(function () {

      $('.js-slider-menu').owlCarousel({
        items: 1,
        margin: 0,
        dots: false,
        loop: true,
        nav: true,
        autoplayHoverPause: true,
        autoplay: true,
        autoplaySpeed: 500,
        autoWidth: true,
        autoHeight: false,
        center: true,
        navText: ['<img src="/wp-content/themes/kobesandaya-html/dist/assets/images/icon-gallery-prev.jpg" />', '<img src="/wp-content/themes/kobesandaya-html/dist/assets/images/icon-gallery-next.jpg" />'],
      });
    });
  }
}




